import { render, staticRenderFns } from "./DetailPatent.vue?vue&type=template&id=e35723cc&scoped=true&"
import script from "./DetailPatent.vue?vue&type=script&lang=ts&"
export * from "./DetailPatent.vue?vue&type=script&lang=ts&"
import style0 from "./DetailPatent.vue?vue&type=style&index=0&id=e35723cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35723cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('e35723cc', component.options)
    } else {
      api.reload('e35723cc', component.options)
    }
    module.hot.accept("./DetailPatent.vue?vue&type=template&id=e35723cc&scoped=true&", function () {
      api.rerender('e35723cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/EnVivo/DetailPatent.vue"
export default component.exports